/** @format */
/// <reference="knockout">
(function (factory) {
  // Module systems magic dance.
  if (
    typeof require === "function" &&
    typeof exports === "object" &&
    typeof module === "object"
  ) {
    // CommonJS or Node: hard-coded dependency on "knockout"
    factory(require("knockout"));
  } else if (typeof define === "function" && define["amd"]) {
    // AMD anonymous module with hard-coded dependency on "knockout"
    define(["knockout"], factory);
  } else {
    // <script> tag: use the global `ko` object, attaching a `validation` property
    factory(ko);
  }
})(function (ko) {
  // this is the factory

  if (typeof ko === "undefined") {
    throw new Error(
      "Knockout is required; please ensure it is loaded before loading this plug-in"
    );
  }

  /**
   * Create a subscription to a Knockout Observable that is removed after a single
   * update.
   *
   * @param {Function} fn a Function to invoke once, and only once, when the value
   *                      of the observable updates. The updated value is passed to the function.
   * @param {ko.observable} observable the Knockout Observable to subscribe to
   */
  function knockoutSubscribeOnce(fn, observable) {
    var subscription = null;

    subscription = observable.subscribe(function (value) {
      // var isPopulatedArray = Array.isArray(value) && value.length >= 1
      // var isTruthy = new Boolean(value)
      // if (isPopulatedArray || isTruthy) {
      // }

      fn(value);
      subscription.dispose();
    });

    return observable;
  }

  /**
   *
   * @method ko.observable.subscribeOnce
   * @param {Observable} target the Knockout Observable
   * @param {Function} option  a Function that will be invoked once and only once when the Observable updates
   */
  ko.extenders.subscribeOnce = function subscribceOnceAdapter(target, option) {
    knockoutSubscribeOnce(option, target);
  };
});
